import React from "react";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./App.routes";
import "./App.css";
import NewsletterModal from '../components/Newsletter/NewsletterModal';
import { SpeedInsights } from "@vercel/speed-insights/react";
import ErrorBoundary from './ErrorBoundary';
import { isReadOnlyPreview } from '../config';
import CartCatalogMonitor from './CartCatalogMonitor';
import SessionMonitor from './SessionMonitor';

const App = () => {

    return (
        <>
            {isReadOnlyPreview && <aside role="status" style={{ padding: '10px 16px', background: '#fff4cf', color: '#423700', textAlign: 'center' }}>
                Förhandsvisning av Dolcehem · Endast offentlig katalog. Beställningar, inloggning och kontoändringar är avstängda.
            </aside>}
            <ToastContainer/>
            <ErrorBoundary>
                <SessionMonitor />
                <CartCatalogMonitor />
                <NewsletterModal/>
                <AppRoutes/>
            </ErrorBoundary>
            {process.env.REACT_APP_ENABLE_SPEED_INSIGHTS === 'true' && <SpeedInsights />}
        </>
    );
};

export default App;
